import { render, staticRenderFns } from "./CmStage.vue?vue&type=template&id=6acd516d"
import script from "./CmStage.vue?vue&type=script&lang=ts"
export * from "./CmStage.vue?vue&type=script&lang=ts"
import style0 from "./CmStage.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LinkComponent: require('/app/components/base/LinkComponent/LinkComponent.vue').default,Headline: require('/app/components/base/Headline/Headline.vue').default,ButtonComponent: require('/app/components/base/ButtonComponent/ButtonComponent.vue').default,VideoComponent: require('/app/components/base/VideoComponent/VideoComponent.vue').default,ImageComponent: require('/app/components/base/ImageComponent/ImageComponent.vue').default,Icon: require('/app/components/base/Icon/Icon.vue').default,Alert: require('/app/components/app/Alert/Alert.vue').default})
